$(function () {
  let section = $('#anfitrion-calendario')
  if (section.get(0) == null) {
    return
  }
  let fullCalendar
  let cargarReservasTimeout = null

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      terrazas: [],
      loaderTerrazas: false,

      filtros: {fecha: null, fecha_fin: null},
      reservas: [],
      fechasEspeciales: {},
      loaderCalendario: false,
      terrazaSeleccionada: null,
      fechaSeleccionada: null,

      scrollTerraza: false,

      //bloqueo o precio especial
      isBloqueo: false,
      hasFechaBloqueo: false,
      hasFechaPrecio: false,
      fechaInicio: null,
      fechaFin: null,
      precioEspecial: null,
      precioHoraExtraEspecial: null,
      disabledDatesInicio: function _default(date) {
        const today = new Date();
        today.setDate(today.getDate() - 1);
        return date < today
      },
      disabledDatesFin: function _default(date) {
        return vueApp.fechaInicio > date
      },
      langFecha: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: true,
      },
    },
    mounted() {
      let terrazaIdSesion = localStorage.getItem("terraza_id")
      if(terrazaId != null && terrazaId.length > 0) {
        this.terrazaSeleccionada = parseInt(terrazaId)
        this.scrollTerraza = true
        localStorage.setItem("terraza_id", terrazaId)
        location.search = ""
      }
      else if(terrazaIdSesion != null && terrazaIdSesion.length > 0){
        this.terrazaSeleccionada = parseInt(terrazaIdSesion)
        this.scrollTerraza = true
      }
      vueApp = this
      initCalendar(this.$refs.calendario);
      this.getTerrazas()
    },
    methods: {
      setTerrazaSeleccionada(terrazaId){
        this.terrazaSeleccionada = terrazaId
        this.getReservasTimeout()
        localStorage.setItem("terraza_id", terrazaId)
      },
      getTerrazas(){
        if (this.loaderTerrazas) {
          return
        }
        this.loaderTerrazas = true
        axios
          .get('/anfitrion/terrazas-json', {
            params: this.filtros,
          })
          .then((respuesta) => {
            vueApp.loaderTerrazas = false
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            vueApp.terrazas = respuesta.data.terrazas;

            if(vueApp.terrazaSeleccionada != null){
              let index = respuesta.data.terrazas.findIndex(item => item.id == vueApp.terrazaSeleccionada)
              if(index < 0){
                vueApp.terrazaSeleccionada = null
              }
            }

            if(vueApp.scrollTerraza){
              if(vueApp.terrazaSeleccionada != null){
                setTimeout(function () {
                  const elements = vueApp.$refs[`terraza-${vueApp.terrazaSeleccionada}`];
                  if(elements == null || elements.length == 0){
                    vueApp.terrazaSeleccionada = null
                  }
                  for(let i in elements){
                    elements[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }, 500)
              }
              vueApp.scrollTerraza = false
            }
            if(vueApp.terrazaSeleccionada == null){
              vueApp.setTerrazaSeleccionada(respuesta.data.terrazas[0].id)
            }
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueApp.loaderTerrazas = false
            Alert("Ocurrió un error inesperado", "info")
          })
      },
      getReservasTimeout(){
        if(cargarReservasTimeout != null){
          clearTimeout(cargarReservasTimeout)
        }
        cargarReservasTimeout = setTimeout(() => {
          vueApp.getReservas()
          cargarReservasTimeout = null
        }, 200)
      },
      getReservas(){
        if (this.loaderCalendario || this.terrazaSeleccionada == null || !isPlanActivo) {
          return
        }
        this.filtros.terraza_id = this.terrazaSeleccionada
        this.loaderCalendario = true
        axios
          .get('/anfitrion/calendario/json', {
            params: this.filtros,
          })
          .then((respuesta) => {
            vueApp.loaderCalendario = false
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            setCalendarioEventos(respuesta.data.reservas, respuesta.data.fechas_especiales)
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueApp.loaderCalendario = false
            Alert("Ocurrió un error inesperado", "info")
          })
      },
      agregarEventoFecha(){
        $("#modalCalendarioEvento").modal("hide")
        $("#modalCalendarioReserva").modal("show")
        let abrirMenu = true
        $('#modalCalendarioReserva').on('hidden.bs.modal', function () {
          if(abrirMenu){
            abrirModalFecha(vueApp.fechaSeleccionada)
          }
        });

        CalendarioReservaVue.agregarReserva(this.terrazaSeleccionada, this.fechaSeleccionada, () => {
          abrirMenu = false
          $("#modalCalendarioReserva").modal("hide")
          vueApp.getReservas()
        })
      },
      bloquearFecha(){
        fechaEspecialModal(vueApp.fechaSeleccionada, true)
      },
      precioEspecialFecha(){
        fechaEspecialModal(vueApp.fechaSeleccionada, false)
      },

      //fecha especial
      sendFechaEspecial(e){
        if(this.fechaInicio > this.fechaFin){
          Alert("La fecha de inicio no puede ser mayor a la de fin", "info")
          return
        }

        let datos = {
          is_bloqueo: this.isBloqueo,
          terraza_id: this.terrazaSeleccionada,
          fecha_inicio: dayjs(this.fechaInicio).format("YYYY-MM-DD"),
          fecha_fin: dayjs(this.fechaFin).format("YYYY-MM-DD"),
          has_bloqueo: this.hasFechaBloqueo,
          has_precio: this.hasFechaPrecio,
        }

        if(!this.isBloqueo){
          datos.precio = parseFloat(this.precioEspecial)
          if(isNaN(datos.precio) || datos.precio == 0){
            datos.precio = null
          }

          datos.precio_hora_extra = parseFloat(this.precioHoraExtraEspecial)
          if(isNaN(datos.precio_hora_extra) || datos.precio_hora_extra == 0){
            datos.precio_hora_extra = null
          }
        }

        $("#btnFechaEspecial").loader("show")

        axios
          .post('/anfitrion/calendario/fecha-especial', datos)
          .then((respuesta) => {
            $("#btnFechaEspecial").loader("hide")
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            let titulo = "Fechas bloqueadas"
            if(!vueApp.isBloqueo){
              titulo = "Precio asignado"
            }
            Alert(titulo, "success")
            vueApp.getReservas()
            fechaEspecialModalCerrar()
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            $("#btnFechaEspecial").loader("hide")
            Alert("Ocurrió un error inesperado", "info")
          })
      }
    }
  });

  function initCalendar(element) {
    fullCalendar = new FullCalendar.Calendar(element, {
      locale: FullCalendar.es,
      firstDay: 0,
      titleFormat: (date) =>{
        return dayjs(date.end.marker).format('MMMM YYYY')
      },
      eventOrder: ['index'],
      plugins: [FullCalendar.dayGridPlugin, FullCalendar.interactionPlugin],
      initialView: 'dayGridMonth',
      dayCellDidMount: function(info) {
        let fecha = dayjs(info.date).format("YYYY-MM-DD")
        let fechaEspecial = vueApp.fechasEspeciales[fecha]
        if(fechaEspecial != null){
          let html = "";
          if(fechaEspecial.is_bloqueado){
            info.el.classList.add("is-bloqueo")
            html += '<div class="bloqueo"><iconify-icon class="icono" icon="zondicons:close-solid"></iconify-icon></div>'
          }
          if(fechaEspecial.precio != null || fechaEspecial.precio_hora_extra != null){
            html += '<div class="precio">'
            if(fechaEspecial.precio != null) {
              html += '<p>'+MonedaFiltro(fechaEspecial.precio)+'</p>'
            }
            if(fechaEspecial.precio_hora_extra != null) {
              html += '<p>'+MonedaFiltro(fechaEspecial.precio_hora_extra)+'</p>'
            }
            html += '</div>'
          }
          info.el.innerHTML = html;
        }
      },
      events: function(fetchInfo, successCallback, failureCallback) {
        vueApp.filtros.fecha = dayjs(fetchInfo.startStr).format("YYYY-MM-DD")
        vueApp.filtros.fecha_fin = dayjs(fetchInfo.endStr).format("YYYY-MM-DD")
        successCallback([]);
        vueApp.getReservasTimeout()
      },
      eventClick: function(info) {
        let eventData = info.event
        let extras = eventData.extendedProps
        window.open("/anfitrion/reservas/" + extras.reserva_id)
      },
      dateClick: function({ dateStr }) {
        if(!isPlanActivo){
          return
        }
        abrirModalFecha(dateStr)
      }
    });
    fullCalendar.render();
  }


  let modalAbrirMenu = true
  function fechaEspecialModalCerrar(){
    modalAbrirMenu = false
    $("#modalFechaEspecial").modal("hide")
  }

  function fechaEspecialModal(fecha, isBloqueo = true){
    modalAbrirMenu = true
    vueApp.isBloqueo = isBloqueo;

    vueApp.fechaInicio = dayjs(fecha).toDate()
    vueApp.fechaFin = dayjs(fecha).toDate()
    vueApp.precioEspecial = null
    vueApp.precioHoraExtraEspecial = null
    if(vueApp.hasFechaPrecio){
      vueApp.precioEspecial = vueApp.fechasEspeciales[fecha].precio
      vueApp.precioHoraExtraEspecial = vueApp.fechasEspeciales[fecha].precio_hora_extra
    }

    $("#modalCalendarioEvento").modal("hide")
    $("#modalFechaEspecial").modal("show")

    $('#modalFechaEspecial').on('hidden.bs.modal', function () {
      if(modalAbrirMenu){
        abrirModalFecha(fecha)
      }
    });
  }

  function abrirModalFecha(fecha){
    if(vueApp.terrazaSeleccionada == null){
      Alert("Selecciona una terraza", "info")
      return
    }
    vueApp.fechaSeleccionada = fecha
    vueApp.hasFechaPrecio = false
    vueApp.hasFechaBloqueo = false
    let fechaEspecial = vueApp.fechasEspeciales[fecha]
    if(fechaEspecial != null){
      vueApp.hasFechaBloqueo = fechaEspecial.is_bloqueado == 1
      vueApp.hasFechaPrecio = fechaEspecial.precio != null || fechaEspecial.precio_hora_extra != null
    }



    let fechaDayjs = dayjs(fecha)
    let titulo = `${fechaDayjs.format("DD")} de ${fechaDayjs.format("MMMM")} de ${fechaDayjs.format("YYYY")}`
    $("#modalCalendarioEvento .modal-title").text(titulo)
    $("#modalCalendarioEvento").modal("show")
  }

  function setCalendarioEventos(reservas, fechasEspeciales){
    try{
      vueApp.reservas = reservas;
      vueApp.fechasEspeciales = fechasEspeciales;
      fullCalendar.removeAllEvents();
      let eventos = [];

      let orden = 0;
      for(let index in reservas){
        let reserva = reservas[index];
        let evento = {
          index: orden,
          reserva_id: reserva.id,
          title: "Evento   " + dayjs(reserva.fecha_inicio).format("HH:mm") +
            " - " + dayjs(reserva.fecha_fin).format("HH:mm"),
          start: reserva.fecha,
          color: "#EF5949",
          extendedProps: {
            index: orden,
            reserva_id: reserva.id,
          }
        }
        eventos.push(evento);
        orden++;
      }

      fullCalendar.addEventSource(eventos);

      fullCalendar.destroy()
      fullCalendar.render()
    }
    catch (error){
      ReportErrorLog(error)
      console.error(error)
    }
  }
});
